import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

import { AgreementCheckbox, TitledRoundedCard } from 'components';

type AgreementCardProp = {
  setIsAgreed: (val: boolean) => void;
};

export const AgreementCard = ({ setIsAgreed }: AgreementCardProp) => {
  const { t } = useTranslation();

  const onChange = (e: CheckboxChangeEvent) => {
    setIsAgreed(e.target.checked);
  };
  return (
    <TitledRoundedCard title={t('enquiry.agreement')} numbering="3">
      <AgreementCheckbox onChange={onChange} />
    </TitledRoundedCard>
  );
};
